import 'core-js/stable'
import Vue from 'vue'
import Notifications from 'vue-notification'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'

import store from './store'
import ToggleButton from 'vue-js-toggle-button'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'leaflet/dist/leaflet.css';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)



Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw'
  },
  // Demonstrating how we can customize the name of the components
  installComponents: false,
});

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications)
Vue.use(ToggleButton)
Vue.use(require('vue-moment'));

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
